
// this is a facade for load-google-maps-api library
// the facade sets up a default options parameter

import loadGoogleMapsApiOriginal from 'load-google-maps-api';

export default function loadGoogleMapsApi( options ) {

	if ( ! options ) {
		options = {
			key: window.googleMapsApiKey
		};
	}

	return loadGoogleMapsApiOriginal( options );
}
